import { fetchBookings } from '@redux/bookings';
import { useAppDispatch } from '@redux/hooks';
import type { Member } from '@typings/membership';
import { useEffect } from 'react';

export const useFetchBookings = (
	categoryCode: string,
	member?: Member | null,
) => {
	const dispatch = useAppDispatch();

	useEffect(() => {
		if (member) {
			dispatch(fetchBookings(categoryCode, member));
		}
	}, [dispatch, categoryCode, member]);
};
